import PropTypes from 'prop-types';
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";

// Reactstrap
import { Button } from "reactstrap";

// Import bileşenleri
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";

// Redux aksiyonları
import { toggleLeftmenu } from "../../store/actions";

const Header = props => {
  const [username, setUsername] = useState("Kullanıcı");
  const [userEmail, setUserEmail] = useState("");

  // Giriş yapan kullanıcının bilgilerini localStorage'dan alıyoruz
  useEffect(() => {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    if (authUser) {
      setUsername(authUser.Users_NameSurname || "Kullanıcı");
      setUserEmail(authUser.Users_Email || "");
    }
  }, []);

  function tToggle() {
    var body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  }

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex align-items-center">
            {/* Hamburger Menü (Sidebar Toggle) */}
            <button
              type="button"
              onClick={() => tToggle()}
              className="btn btn-sm px-3 font-size-16 header-item waves-effect"
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars" />
            </button>

            {/* Kullanıcı Bilgisi (Avatar | İsim | Email) */}
            <div className="d-none d-md-flex align-items-center ms-3">
               <div className="rounded-circle bg-light d-flex align-items-center justify-content-center me-2" style={{width: '32px', height: '32px'}}>
                  <i className="bx bx-user font-size-18 text-muted"></i>
               </div>
               <div className="text-start">
                  <span className="fw-medium text-dark">{username}</span>
                  <span className="text-muted ms-1">| {userEmail}</span>
               </div>
            </div>
          </div>

          <div className="d-flex align-items-center">
            {/* Geri Bildirim Gönder Butonu */}
            <div className="d-none d-sm-block me-3">
              <Button 
                color="dark" 
                className="btn-sm px-3 d-flex align-items-center"
                style={{ backgroundColor: '#1b264f', borderColor: '#1b264f' }}
              >
                Geri Bildirim Gönder 
                <i className="mdi mdi-email-outline ms-2"></i>
              </Button>
            </div>

            {/* Bildirimler */}
            <NotificationDropdown />

            {/* Profil Menüsü / Çıkış */}
            <ProfileMenu />
            
            {/* Hızlı Çıkış Bağlantısı (Ekran görüntüsündeki gibi) */}
            <div className="ms-2 d-none d-md-block">
                <Link to="/logout" className="text-muted waves-effect d-flex align-items-center">
                    <span className="me-1">Çıkış</span>
                    <i className="mdi mdi-logout font-size-16"></i>
                </Link>
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

Header.propTypes = {
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func
};

const mapStatetoProps = state => {
  const { showRightSidebar, leftMenu, leftSideBarType } = state.Layout;
  return { showRightSidebar, leftMenu, leftSideBarType };
};

export default connect(mapStatetoProps, { toggleLeftmenu })(withTranslation()(Header));